
let commonUtils = require('@/utils/common_utils');

class TransportHelper {
    //获取物流公司logo  deliver表示物流数据
    static getDeliverLogo(deliver) {
        let data = this.getDeliverData(deliver);
        return data.logoUrl;
    }

    static getDeliverName(deliver) {
        let data = this.getDeliverData(deliver);
        return data.name;
    }

    //获取物流官网查询链接
    static getDeliverUrl(deliver) {
        let data = this.getDeliverData(deliver);
        return data.url;
    }

    //获取物流订单号
    static getDeliverTransportOrderId(deliver) {
        let data = this.getDeliverData(deliver);
        return data.transportOrderId;
    }

    //获取物流信息
    static getTransportData(commandeGroup) {
        console.log('transportDatas',commandeGroup);
        if (commonUtils.isEmpty(commandeGroup.commandes[0].livraison)) return [];
        let transportDatas = [];
        for (let commande of commandeGroup.commandes) {
            let arrDeliverData = [];
            if (!commonUtils.isEmpty(commande.commandes_etiquettes)) {
                for (let commandes_etiquette of commande.commandes_etiquettes) {
                    commande.livraison.transportData = JSON.parse(commandes_etiquette.etiquette);
                    let data = this.getDeliverData(commande.livraison);
                    arrDeliverData.push(data);
                }
            }
            transportDatas.push(arrDeliverData);
        }
        console.log('transportDatas',transportDatas);
        return transportDatas;
    }

    static getDeliverData(deliver) {
        if (!deliver) return {};
        let id_livraison = deliver.id_livraison;
        let logoUrl = require('@/assets/img/deliver/colissimo.png');
        let name = '';
        let transportData = deliver.transportData;
        console.log(deliver)
        //物流公司的订单id
        let transportOrderId = '';
        let url = '';
        try { // colissimo 1
            // dpd 10
            // epsp 4
            // gpx	3
            // ocx 7
            // ups 19
            // ups_group 19
            switch (id_livraison) {
                case 1:
                    logoUrl = require('@/assets/img/deliver/colissimo.png');
                    name = 'Colissimo';
                    if (transportData) transportOrderId = transportData.getLetterColissimoReturn.parcelNumber;
                    url = `https://www.laposte.fr/particulier/outils/suivre-vos-envois?code=${transportOrderId}`
                    break;
                case 10:
                case 13:
                    logoUrl = require('@/assets/img/deliver/dpd.png');
                    name = 'dpd';
                    console.log('transportData', transportData)
                    if (transportData) {
                        if (transportData.shipments && transportData.shipments.length > 0 && transportData.shipments[0].parcelNumber) {
                            transportOrderId = transportData.shipments[0].parcelNumber;
                        } else {
                            transportOrderId = transportData.trackingNumber;
                        }
                    }

                    url = `http://www.dpd.fr/traces_092${transportOrderId}`;
                    break;
                case 4:
                    logoUrl = require('@/assets/img/deliver/epsp.png');
                    name = 'Epsp';
                    break;
                case 3:
                    logoUrl = require('@/assets/img/deliver/gpx.png');
                    name = 'Gpx';
                    break;
                case 7:
                    logoUrl = require('@/assets/img/deliver/ocx.png');
                    name = 'Ocx';
                    break;
                case 19:
                    logoUrl = deliver.multi === 1 ? require('@/assets/img/deliver/ups_group.png') : require('@/assets/img/deliver/ups.png');
                    name = deliver.multi === 1 ? 'Groupage Ups' : 'Ups';
                    if (transportData) transportOrderId = transportData.TrackingNumber;
                    url = `https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${transportOrderId}`;
                    break;
            }
            if (!transportOrderId) url = '';
            return {logoUrl, name, url, transportOrderId};
        } catch (e) {
            return {logoUrl, name, url, transportOrderId};
        }
    }
}

module.exports = TransportHelper;
